import PropTypes from 'prop-types'
import React from 'react'
import _ from 'lodash'
import MonthCell from '#components/m/MonthPicker/MonthCell'

function MonthList({selectedMonths, markedMonths, monthChanged}) {
  return (
    <div className="monthpicker__monthlist">
      {_.range(0, 12).map(i => {
        const isSelected = selectedMonths && selectedMonths.indexOf(i) >= 0
        const isMarked = markedMonths && markedMonths.indexOf(i) >= 0

        return <MonthCell month={i} key={i} isActive={isSelected} isMarked={isMarked} monthChanged={monthChanged} />
      })}
    </div>
  )
}

MonthList.propTypes = {
  monthChanged: PropTypes.func,
  selectedMonths: PropTypes.arrayOf(PropTypes.number),
  markedMonths: PropTypes.arrayOf(PropTypes.number),
}

export default MonthList
